import {
  NotificationPreferenceSubcategoryDto,
  NotificationPreferenceSubcategoryItem,
} from "../types";

export class PreferenceStaticFieldMapper {
  readonly preferencesFieldMap = {
    email_enabled: {
      title: "Email",
      description: "Receive email notifications",
    },
    push_notifications: {
      title: "Push Notifications",
      description: "Receive push notifications on your browser",
    },
  };

  readonly diffCheckFieldMap = {
    brownfields: {
      title: "Brownfields",
      description:
        "Get notified whenever new brownfields are found near this location",
    },
    superfunds: {
      title: "Superfunds",
      description:
        "Get notified whenever new superfunds are found near this location",
    },
    natural_gas_pipelines: {
      title: "Natural Gas Pipelines",
      description:
        "Get notified whenever new natural gas pipelines are found near this location",
    },
    oil_wells: {
      title: "Oil, Gas, & Fracking Wells",
      description:
        "Get notified whenever new oil wells are found near this location",
    },
    cell_towers: {
      title: "Cell Towers",
      description:
        "Get notified whenever new cell towers are found near this location",
    },
    solid_waste_landfills: {
      title: "Solid Waste Landfills",
      description:
        "Get notified whenever new solid waste landfills are found near this location",
    },
    high_voltage_lines: {
      title: "High Voltage Lines",
      description:
        "Get notified whenever new high voltage lines are found near this location",
    },
    power_plants: {
      title: "Power Plants",
      description:
        "Get notified whenever new power plants are found near this location",
    },
    toxic_release_inventory: {
      title: "Toxic Release Inventory",
      description:
        "Get notified when new toxic chemical releases and pollution prevention activities are reported by industrial and federal facilities.",
    },
  };

  readonly capFieldMap = {
    air_quality_alert: {
      title: "Air Quality Alerts",
      description: `Used to relay non-routine air quality alert messages issued by state and local agencies.  It is only meant to convey the official information from the state and local air quality agencies.

Air quality conditions reach or are expected to reach "unhealthy" or worse (AQI 151 to 200 or above)`,
    },
    winter_storm_watch: {
      title: "Winter Storm Watch",
      description:
        "A Winter Storm Watch is issued when there is the potential for significant and hazardous winter weather within 48 hours. It does not mean that significant and hazardous winter weather will occur...it only means it is possible.\n" +
        "\n" +
        "Significant and hazardous winter weather is defined as a combination of:1. 5 inches or more of snow/sleet within a 12-hour period or 7 inches or more of snow/sleet within a 24-hour period\n" +
        "2. Enough ice accumulation to cause damage to trees or powerlines.\n" +
        "3. A life threatening or damaging combination of snow and/or ice accumulation with wind.\n" +
        "\n" +
        "The snow/sleet criteria for a Winter Storm Watch for the five westernmost counties (Allegany, Mineral, Grant, Pendleton, and Highland) is higher (6 inches or more within a 12-hour period; 8 inches or more within a 24-hour period).\n" +
        "\n",
    },
    blizzard_warning: {
      title: "Blizzard Warning",
      description:
        "A Blizzard Warning means that the following conditions are occurring or expected within the next 12 to 18 hours.1. Snow and/or blowing snow reducing visibility to 1/4 mile or less for 3 hours or longer\n" +
        "2. Sustained winds of 35 mph or greater or frequent gusts to 35 mph or greater.\n" +
        "There is no temperature requirement that must be met to achieve blizzard conditions.\n" +
        "\n",
    },
    winter_storm_warning: {
      title: "Winter Storm Warning",
      description:
        "A Winter Storm Warning is issued when a significant combination of hazardous winter weather is occurring or imminent.\n" +
        "\n" +
        "Significant and hazardous winter weather is defined as a combination of:1.  5 inches or more of snow/sleet within a 12-hour period or 7 inches or more of snow/sleet within a 24-hour period\n" +
        "2.  Enough ice accumulation to cause damage to trees or powerlines.\n" +
        "3.  a life threatening or damaging combination of snow and/or ice accumulation with wind.\n" +
        "\n" +
        "The snow/sleet criteria for a Winter Storm Warning for the five westernmost counties (Allegany, Mineral, Grant, Pendleton, and Highland) is higher (6 inches or more within a 12-hour period; 8 inches or more within a 24-hour period).\n" +
        "\n",
    },
    ice_storm_warning: {
      title: "Ice Storm Warning",
      description: "¼ inch or more of ice accumulation.\n\n",
    },
    winter_weather_advisory: {
      title: "Winter Weather Advisory",
      description:
        "A Winter Weather Advisory will be issued for any amount of freezing rain, or when 2 to 4 inches of snow (alone or in combination with sleet and freezing rain), is expected to cause a significant inconvenience, but not serious enough to warrant a warning.\n" +
        "\n" +
        "If the event is expected to impact the Baltimore/Washington metro areas during rush hours (4-9 am or 2-7 pm on weekdays) forecasted snow totals of one inch will necessitate the issuance of a winter weather advisory. The snow/sleet criteria for a Winter Weather Advisory for the five westernmost counties (Allegany, Mineral, Grant, Pendleton, and Highland) is higher (3-5 inches).\n" +
        " \n" +
        "\n",
    },
    freeze_watch: {
      title: "Freeze Watch",
      description:
        "A Freeze Watch is issued when there is a potential for significant, widespread freezing temperatures within the next 24-36 hours.\n" +
        "\n" +
        "A Freeze Watch is issued in the autumn until the end of the growing season (marked by the occurrence of first widespread freeze). The normal end of the growing season is mid to late October west of the Blue Ridge and early November east of the Blue Ridge. However, during anomalously warm autumns, the growing season may be extended past the normal end of the growing season.\n" +
        "\n" +
        "A Freeze Watch is issued in the spring at the start of the growing season (when it is late enough to cause damage to new plants and crops).\n" +
        "\n",
    },
    freeze_warning: {
      title: "Freeze Warning",
      description:
        "A Freeze Warning is issued when significant, widespread freezing temperatures are expected.\n" +
        "\n" +
        "A Freeze Warning is issued in the autumn until the end of the growing season (marked by the occurrence of first widespread freeze). The normal end of the growing season is mid to late October west of the Blue Ridge and early November east of the Blue Ridge. However, during anomalously warm autumns, the growing season may be extended past the normal end of the growing season.\n" +
        "\n" +
        "A Freeze Warning is issued in the spring at the start of the growing season (when it is late enough to cause damage to new plants and crops).\n" +
        "\n",
    },
    frost_advisory: {
      title: "Frost Advisory",
      description:
        "A Frost Advisory is issued when the minimum temperature is forecast to be 33 to 36 degrees on clear and calm nights during the growing season.\n" +
        "\n" +
        "A Frost Advisory is issued in the autumn until the end of the growing season (marked by the occurrence of first widespread freeze). The normal end of the growing season is mid to late October west of the Blue Ridge and early November east of the Blue Ridge. However, during anomalously warm autumns, the growing season may be extended past the normal end of the growing season.\n" +
        "\n" +
        "A Frost Advisory is issued in the spring at the start of the growing season (when it is late enough to cause damage to new plants and crops).\n" +
        "\n",
    },
    wind_chill_advisory: {
      title: "Wind Chill Advisory",
      description:
        "A Wind Chill Advisory is issued when wind chills of -5F to -19F are expected east of the Blue Ridge Mountains, and when wind chills of -10 to -24F are expected along and west of the Blue Ridge Mountains and in Frederick and Carroll Counties in Maryland.\n" +
        "\n",
    },
    wind_chill_warning: {
      title: "Wind Chill Warning",
      description:
        "A Wind Chill Warning is issued when wind chills of -20F or lower are expected east of the Blue Ridge Mountains, and when wind chills of -25F or lower are expected along and west of the Blue Ridge Mountains and in Frederick and Carroll Counties in Maryland.\n" +
        "\n",
    },
    fire_weather_watch: {
      title: "Fire Weather Watch",
      description:
        "A Fire Weather Watch is issued to alert fire officials and firefighters of potentially dangerous fire weather conditions within the next 24 to 36 hours. They are issued when the following three criteria are met:\n" +
        "\n" +
        "1. Surface relative humidity (RH) less than 30 % for VA and MD; RH less than or equal to 25% for WV\n" +
        "2. Sustained surface wind of 20 MPH or greater AND\n" +
        "3. 10-hour fuel moisture less than 8% for VA; less than or equal to 8% for MD and WV\n" +
        "\n",
    },
    red_flag_warning: {
      title: "Red Flag Warning",
      description:
        "A Red Flag Warning is issued to alert fire officials and firefighters of potentially dangerous fire weather conditions within the next 12 to 24 hours. They are issued when the following three criteria are met:\n" +
        "\n" +
        "1. Surface relative humidity (RH) less than 30 % for VA and MD; RH less than or equal to 25% for WV\n" +
        "2. Sustained surface wind of 20 MPH or greater AND\n" +
        "3. 10-hour fuel moisture less than 8% for VA; less than or equal to 8% for MD and WV",
    },
    dense_fog_advisory: {
      title: "Dense Fog Advisory",
      description:
        "A Dense Fog Advisory is issued when widespread fog is expected to reduce visibilities to 1/4 mile or less over a large area for an extended period of time (2 or more hours).\n" +
        "\n",
    },
    high_wind_watch: {
      title: "High Wind Watch",
      description:
        "A High Wind Watch is issued when the following conditions are possible:\n" +
        "\n" +
        "1. Sustained winds of 40 mph or higher for one hour or more\n" +
        "2. Wind gusts of 58 mph or higher for any duration.\n" +
        "\n",
    },
    high_wind_warning: {
      title: "High Wind Warning",
      description:
        "A High Wind Warning is issued when the following conditions are expected:\n" +
        "\n" +
        "1. Sustained winds of 40 mph or higher for one hour or more\n" +
        "2. Wind gusts of 58 mph or higher for any duration.\n" +
        "\n",
    },
    wind_advisory: {
      title: "Wind Advisory",
      description:
        "A Wind Advisory is issued when the following conditions are expected:\n" +
        "\n" +
        "1. Sustained winds of 31 to 39 mph for an hour or more.\n" +
        "2. Wind gusts of 46 to 57 mph for any duration.\n" +
        "\n",
    },
    severe_thunderstorm_watch: {
      title: "Severe Thunderstorm Watch",
      description:
        "A Severe Thunderstorm Watch is issued when severe thunderstorms are possible in and near the watch area. It does not mean that they will occur. It only means they are possible.\n" +
        "\n" +
        "Severe thunderstorms are defined as follows:\n" +
        "\n" +
        "1. Winds of 58 mph or higher\n" +
        "2. Hail 1 inch in diameter or larger.\n" +
        "\n",
    },
    severe_thunderstorm_warning: {
      title: "Severe Thunderstorm Warning",
      description:
        "A Severe Thunderstorm Warning is issued when severe thunderstorms are occurring or imminent in the warning area.\n" +
        "\n" +
        "Severe thunderstorms are defined as follows:\n" +
        "\n" +
        "1. Winds of 58 mph or higher\n" +
        "2. Hail 1 inch in diameter or larger.\n" +
        "\n",
    },
    tornado_watch: {
      title: "Tornado Watch",
      description:
        "A Tornado Watch is issued when severe thunderstorms and tornadoes are possible in and near the watch area. It does not mean that they will occur. It only means they are possible.\n" +
        "\n" +
        "Severe thunderstorms are defined as follows:\n" +
        "\n" +
        "1. Winds of 58 mph or higher\n" +
        "2. Hail 1 inch in diameter or larger.\n" +
        "\n",
    },
    tornado_warning: {
      title: "Tornado Warning",
      description:
        "A Tornado Warning is issued when a tornado is imminent. When a tornado warning is issued, seek safe shelter immediately.\n" +
        "\n",
    },
    extreme_wind_warning: {
      title: "Extreme Wind Warning",
      description:
        "An Extreme Wind Warning is issued for surface winds of 100 knots (115 MPH) or greater associated with non-convective, downslope, derecho (NOT associated with a tornado), or sustained hurricane winds are expected to occur within one hour.\n" +
        "\n",
    },
    small_craft_advisory: {
      title: "Small Craft Advisory",
      description:
        "Small Craft Advisories are issued for the Tidal Potomac River and the Chesapeake Bay when one or both of the following conditions is expected to begin within 36 hours:\n" +
        "\n" +
        "1. Sustained winds of 18 knots to 33 knots\n" +
        "2. Frequent gusts (duration of two or more hours) between 18 knots and 33 knots.\n" +
        "3. Waves of 4 feet or higher\n" +
        "\n",
    },
    gale_warning: {
      title: "Gale Warning",
      description:
        "Gale Warnings are issued for the Tidal Potomac River and the Chesapeake Bay when one or both of the following conditions is expected to begin within 36 hours and not directly associated with a tropical cyclone:\n" +
        "\n" +
        "1. Sustained winds of 34 knots to 47 knots\n" +
        "2. Frequent gusts (duration of two or more hours) between 34 knots and 47 knots.\n" +
        "\n",
    },
    storm_warning: {
      title: "Storm Warning",
      description:
        "Storm Warnings are issued for the Tidal Potomac River and the Chesapeake Bay when one or both of the following conditions is expected to begin within 36 hours and not directly associated with a tropical cyclone:\n" +
        "\n" +
        "1. Sustained winds of 48 knots to 63 knots\n" +
        "2. Frequent gusts (duration of two or more hours) of 48 knots to 63 knots\n" +
        "\n",
    },
    hurricane_force_wind_warning: {
      title: "Hurricane Force Wind Warning",
      description:
        "Hurricane Force Wind Warnings are issued for the Tidal Potomac River and the Chesapeake Bay when one or both of the following conditions is expected to begin within 36 hours and not directly associated with a tropical cyclone:\n" +
        "\n" +
        "1. Sustained winds of 64 knots or greater\n" +
        "2. Frequent gusts (duration of two or more hours) of 64 knots or greater\n" +
        "\n",
    },
    special_marine_warning: {
      title: "Special Marine Warning",
      description:
        "A warning of potentially hazardous weather conditions of short duration (up to 2 hours) affecting areas included in a CWF that are not adequately covered by existing marine warnings and producing one or more of the following:\n" +
        "\n" +
        "1. Sustained marine convective winds (showers/thunderstorms) or associated gusts of 34 knots or greater\n" +
        "2. Hail three quarters of an inch or more in diameter\n" +
        "3. Waterspouts\n" +
        "\n",
    },
    coastal_flood_watch: {
      title: "Coastal Flood Watch",
      description:
        "A Coastal Flood Watch is issued when moderate to major coastal flooding is possible. Such flooding would potentially pose a serious risk to life and property.\n" +
        "\n" +
        "Coastal Flood Watches are issued for coastal areas along the Tidal Potomac River and coastal areas along the Chesapeake Bay.\n" +
        "\n",
    },
    coastal_flood_warning: {
      title: "Coastal Flood Warning",
      description:
        "A Coastal Flood Warning is issued when moderate to major coastal flooding is occurring or imminent. This flooding will pose a serious risk to life and property.\n" +
        "\n" +
        "Coastal Flood Warnings are issued for coastal areas along the Tidal Potomac River and areas along the Chesapeake Bay.\n" +
        "\n",
    },
    coastal_flood_advisory: {
      title: "Coastal Flood Advisory",
      description:
        "A Coastal Flood Advisory is issued when minor or nuisance coastal flooding is occurring or imminent.\n" +
        "\n" +
        "Coastal Flood Advisories are issued for coastal areas along the Tidal Potomac River and areas along the Chesapeake Bay.\n" +
        "\n",
    },
    flash_flood_watch: {
      title: "Flash Flood Watch",
      description:
        "A Flash Flood Watch is issued when conditions are favorable for flash flooding. It does not mean that flash flooding will occur, but it is possible.\n" +
        "\n",
    },
    flash_flood_warning: {
      title: "Flash Flood Warning",
      description:
        "A Flash Flood Warning is issued when flash flooding is imminent or occurring.\n" +
        "\n",
    },
    flood_watch: {
      title: "Flood Watch",
      description:
        "A Flood Watch is issued when conditions are favorable for flooding. It does not mean flooding will occur, but it is possible.\n" +
        "\n",
    },
    flood_warning: {
      title: "Flood Warning",
      description:
        "A Flood Warning is issued when flooding is imminent or occurring.\n\n",
    },
    river_flood_watch: {
      title: "River Flood Watch",
      description:
        "A River Flood Watch is issued when river flooding is possible at one or more forecast points along a river.\n" +
        "\n",
    },
    river_flood_warning: {
      title: "River Flood Warning",
      description:
        "A River Flood Warning is issued when river flooding is occurring or imminent at one or more forecast points along a river.\n" +
        "\n",
    },
    excessive_heat_watch: {
      title: "Excessive Heat Watch",
      description:
        "An Excessive Heat Watch is issued when there is a potential for the heat index value to reach or exceed 110 degrees (east of the Blue Ridge) or 105 degrees (west of the Blue Ridge) within the next 24 to 48 hours.\n" +
        "\n",
    },
    excessive_heat_warning: {
      title: "Excessive Heat Warning",
      description:
        "An Excessive Heat Warning is issued when the heat index value is expected to reach or exceed 110 degrees (east of the Blue Ridge) or 105 degrees (west of the Blue Ridge) within the next 12 to 24 hours. An Excessive Heat Warning may be issued for lower criteria if it is early in the season or during a multi-day heat wave.\n" +
        "\n",
    },
    heat_advisory: {
      title: "Heat Advisory",
      description:
        "A Heat Advisory is issued when the heat index value is expected to reach 105 to 109 degrees (east of the Blue Ridge) or 100 to 104 degrees (west of the Blue Ridge) within the next 12 to 24 hours. A Heat Advisory may be issued for lower criteria if it is early in the season or during a multi-day heat wave.\n" +
        "\n",
    },
    tropical_storm_watch: {
      title: "Tropical Storm Watch",
      description:
        "A Tropical Storm Watch is issued when a tropical cyclone containing winds of 34 to 63 kt (39 to 73 mph) or higher poses a possible threat, generally within 48 hours. These winds may be accompanied by storm surge, coastal flooding, and/or river flooding.\n" +
        "\n" +
        "The watch does not mean that tropical storm conditions will occur. It only means that these conditions are possible.\n" +
        "\n",
    },
    tropical_storm_warning: {
      title: "Tropical Storm Warning",
      description:
        "A Tropical Storm Warning is issued when sustained winds of 34 to 63 kt (39 to 73 mph) or higher associated with a tropical cyclone are expected in 36 hours or less. These winds may be accompanied by storm surge, coastal flooding, and/or river flooding.\n" +
        "\n",
    },
    hurricane_watch: {
      title: "Hurricane Watch",
      description:
        "A Hurricane Watch is issued when a tropical cyclone containing winds of 64 kt (74 mph) or higher poses a possible threat, generally within 48 hours. These winds may be accompanied by storm surge, coastal flooding, and/or river flooding.\n" +
        "\n" +
        "The watch does not mean that hurricane conditions will occur. It only means that these conditions are possible.\n" +
        "\n",
    },
    hurricane_warning: {
      title: "Hurricane Warning",
      description:
        "A Hurricane Warning is issued when sustained winds of 64 kt (74 mph) or higher associated with a tropical cyclone are expected in 36 hours or less. These winds may be accompanied by storm surge, coastal flooding, and/or river flooding. A hurricane warning can remain in effect when dangerously high water or a combination of dangerously high water and exceptionally high waves continue, even though winds may be less than hurricane force.\n" +
        "\n",
    },
    "911_telephone_outage_emergency": {
      title: "911 Telephone Outage Emergency",
      description:
        "A 911 Telephone Outage Emergency (S.A.M.E code: TOE) is an emergency message that notifies listeners of a local or state 911 telephone network outage by geographic area or telephone exchange.",
    },
    administrative_message: {
      title: "Administrative Message",
      description:
        "An Administrative Message is a non-emergency message used to provide updated information about a developing situation, an event that has concluded or has been resolved, a pre-event preparation, or other administrative matters pertaining to the Emergency Alert System.",
    },
    air_stagnation_advisory: {
      title: "Air Stagnation Advisory",
      description:
        "A statement issued by a National Weather Service forecast office when atmospheric conditions are stable enough such that the potential exists for air pollutants to accumulate in a given area.",
    },
    ashfall_advisory: {
      title: "Ashfall Advisory",
      description:
        "An Ashfall advisory is a weather advisory issued by the National Weather Service of the United States. Ashfall advisories are issued when there is a likely future or present occurrence of ash rain caused by a large plume of suspended airborne ash, typically caused by large fires or volcanic activity.",
    },
    ashfall_warning: {
      title: "Ashfall Warning",
      description:
        "An Ashfall Warning means that a volcano undergoing a major eruption is creating the likelihood of significant impact on the public (with higher risk to the health of people with respiratory illnesses) and maritime activity due to ashfall accumulation forecast to be greater than or equal to 0.25 inches (6.4 mm), significant debris, lava, or lahar flows.",
    },
    avalanche_advisory: {
      title: "Avalanche Advisory",
      description:
        "A preliminary notification that conditions may be favorable for the development of avalanches in mountain regions.",
    },
    avalanche_warning: {
      title: "Avalanche Warning",
      description:
        "Issued by the National Weather Service when avalanches are imminent or occurring in the mountains. It is usually issued for a 24 hour period.",
    },
    avalanche_watch: {
      title: "Avalanche Watch",
      description:
        "The purpose of an Avalanche Watch is to warn the public that Avalanche Warning criteria are likely to be met in 24-48 hours.",
    },
    beach_hazards_statement: {
      title: "Beach Hazards Statement",
      description:
        "The Beach Hazards Statement (BHS) informs beach goers and local authorities to a multitude of hazards including, but not limited to: rip currents (or other types of dangerous currents in the surf zone), unusually cold water temperatures, potential for lightning along the beach/shoreline, or unusual surf/wave conditions which do not meet advisory criteria. In coordination with other agencies (as needed), the product may also inform users of various types of environmental hazards (e.g. chemical spills, harmful algal blooms, high bacteria levels in the water, or potentially hazardous marine wildlife which may be impacting the area).",
    },
    blizzard_watch: {
      title: "Blizzard Watch",
      description:
        "A blizzard watch was a bulletin issued by the National Weather Service of the United States which meant winds greater than 35 miles per hour (30 kn; 56 km/h), mixed with falling or blowing snow, and visibilities of 1⁄4 mile (0.4 km) or less is forecast for a period of 3 hours or more. A blizzard watch was issued 12 to 48 hours before an expected blizzard event. As the forecast solidifies, a blizzard watch would be either downgraded to a winter storm warning or winter weather advisory for blowing snow (depending on accumulation amounts) or upgraded to a blizzard warning.",
    },
    blowing_dust_advisory: {
      title: "Blowing Dust Advisory",
      description:
        "Long duration event of widespread or localized blowing dust reducing visibilities to one mile or less, but greater than 1/4 mile.",
    },
    blowing_dust_warning: {
      title: "Blowing Dust Warning",
      description:
        "A long duration event of widespread or localized blowing dust reducing visibilities to 1/4 mile or less.",
    },
    brisk_wind_advisory: {
      title: "Brisk Wind Advisory",
      description:
        "A Small Craft Advisory issued by the National Weather Service for ice-covered waters.Jun 25, 2009",
    },
    child_abduction_emergency: {
      title: "Child Abduction Emergency",
      description:
        "A Child Abduction Emergency is a type of alert that is issued whenever a child is in imminent danger due to abduction. This alert is issued by a civil authority and is sometimes relayed by the National Weather Service (NWS).",
    },
    civil_danger_warning: {
      title: "Civil Danger Warning",
      description:
        "A civil danger warning is a warning issued through the Emergency Alert System (EAS) in the United States to warn the public of an event that presents a danger to a significant civilian population. It is typically issued by a local or state authority and is relayed by the National Weather Service.",
    },
    civil_emergency_message: {
      title: "Civil Emergency Message",
      description:
        "A civil emergency message is a warning issued through the Emergency Alert System (EAS) in the United States to warn the public of a significant in-progress or imminent threat or danger to public safety. It is typically issued by a local or state authority and is relayed by the National Weather Service.",
    },
    coastal_flood_statement: {
      title: "Coastal Flood Statement",
      description:
        "A Coastal Flood Statement is issued when minor or nuisance coastal flooding is occurring or imminent.",
    },
    dense_smoke_advisory: {
      title: "Dense Smoke Advisory",
      description:
        "A Dense Smoke Advisory is issued when widespread or localize smoke reduces visibilities to 1/4 mile or less.",
    },
    dust_advisory: {
      title: "Dust Advisory",
      description:
        "A sudden drop in visibility to one mile or less, but greater than 1/4 mile, resulting in widespread or localized blowing dust.",
    },
    dust_storm_warning: {
      title: "Dust Storm Warning",
      description:
        "A sudden drop in visibility to 1/4 mile or less resulting in widespread or localized blowing dust.",
    },
    earthquake_warning: {
      title: "Earthquake Warning",
      description:
        "A warning of current or imminent earthquake activity. Authorized officials may recommend or order protective actions according to state law or local ordinance.",
    },
    evacuation_immediate: {
      title: "Evacuation - Immediate",
      description:
        "A warning where immediate evacuation is recommended or ordered according to state law or local ordinance. As an example, authorized officials may recommend the evacuation of affected areas due to an approaching tropical cyclone. In the event a flammable or explosive gas is released, authorized officials may recommend evacuation of designated areas where casualties or property damage from a vapor cloud explosion or fire may occur.",
    },
    extreme_cold_warning: {
      title: "Extreme Cold Warning",
      description:
        "When the air temperature is dangerously cold, but the wind was too little to warrant a Wind Chill Watch or Warning. Extreme Cold Warning and the Wind Chill Warning will be consolidated into the Extreme Cold Warning, meaning that this product would once again be issued on a regular basis. This change was hinted to take effect sometime in 2021, accounting for NWS software upgrades",
    },
    extreme_cold_watch: {
      title: "Extreme Cold Watch",
      description:
        "Dangerously low temperatures are possible for a prolonged period of time.",
    },
    extreme_fire_danger: {
      title: "Extreme Fire Danger",
      description:
        "Issued in areas where fires will start and spread rapidly. Every fire start has the potential to become large. Expect extreme, erratic fire behavior.",
    },
    fire_warning: {
      title: "Fire Warning",
      description:
        "A Fire Warning is a warning issued by civil authorities in the United States to inform the public of major, uncontrolled fires (usually wildfires) threatening populated areas and/or major roadways.",
    },
    flash_flood_statement: {
      title: "Flash Flood Statement",
      description:
        "Message issued after a Flash Flood Warning when flash flooding is actually occurring or imminent in a warning area. It is issued every one to six hours to update information provided in the previous Flash Flood Statement, or in the original Flash Flood Warning.",
    },
    flood_advisory: {
      title: "Flood Advisory",
      description:
        "A Flood Warning is issued when the hazardous weather event is imminent or already happening. A Flood Warning is issued when flooding is imminent or occurring.",
    },
    flood_statement: {
      title: "Flood Statement",
      description:
        "Bulletin issued to provide updated information about flooding along main stem rivers, or important creeks.",
    },
    freezing_fog_advisory: {
      title: "Freezing Fog Advisory",
      description:
        "A Freezing Fog Advisory is issued by your local National Weather Service office when fog develops and surface temperatures are at or below freezing.",
    },
    freezing_rain_advisory: {
      title: "Freezing Rain Advisory",
      description:
        "A Freezing Rain Advisory indicates that ice accumulation of up to 1/4 inch is expected",
    },
    freezing_spray_advisory: {
      title: "Freezing Spray Advisory",
      description:
        "An advisory for an accumulation of freezing water droplets on a vessel at a rate of less than 2 centimeters (cm) per hour caused by some appropriate combination of cold water, wind, cold air temperature, and vessel movement.",
    },
    gale_watch: {
      title: "Gale Watch",
      description:
        "A gale watch is issued by the National Weather Service of the United States when there is an increased risk for a gale-force wind event, meaning sustained surface winds, or frequent gusts, of 34 to 47 knots (39 to 54 mph), but the occurrence, location, and/or timing of the event is still uncertain.",
    },
    hard_freeze_warning: {
      title: "Hard Freeze Warning",
      description:
        "When temperatures are forecasted to go below 32°F for a long period of time, NWS issues a freeze warning.",
    },
    hard_freeze_watch: {
      title: "Hard Freeze Watch",
      description:
        "A Hard Freeze Watch may be issued a few days ahead of time if the potential exists for temperatures to fall below 32°F for a long period of time.",
    },
    hazardous_materials_warning: {
      title: "Hazardous Materials Warning",
      description:
        "A warning of the release of a non-radioactive hazardous material (such as a flammable gas, toxic chemical, or biological agent) that may recommend evacuation (for an explosion, fire or oil spill hazard) or shelter in place (for a toxic fume hazard).",
    },
    hazardous_seas_warning: {
      title: "Hazardous Seas Warning",
      description:
        "A Hazardous Seas Warning is issued by the National Weather Service of the United States when wave heights and/or wave steepness values reach certain criteria. These criteria are defined by the local forecast office. Such tall waves can pose a serious threat to vessels that do not seek shelter.",
    },
    hazardous_seas_watch: {
      title: "Hazardous Seas Watch",
      description:
        "A watch for an increased risk of a hazardous seas warning event to meet Hazardous Seas Warning criteria but its occurrence, location, and/or timing is still uncertain.",
    },
    hazardous_weather_outlook: {
      title: "Hazardous Weather Outlook",
      description:
        "A weather statement issued to provide information of potential severe weather events within the next seven days.",
    },
    heavy_freezing_spray_warning: {
      title: "Heavy Freezing Spray Warning",
      description:
        "A warning for an accumulation of freezing water droplets on a vessel at a rate of 2 cm per hour or greater caused by some appropriate combination of cold water, wind, cold air temperature, and vessel movement",
    },
    heavy_freezing_spray_watch: {
      title: "Heavy Freezing Spray Watch",
      description:
        "A warning for an accumulation of freezing water droplets on a vessel at a rate of 2 cm per hour or greater caused by some appropriate combination of cold water, wind, cold air temperature, and vessel movement.",
    },
    high_surf_advisory: {
      title: "High Surf Advisory",
      description:
        "A High Surf Advisory is issued when breaking wave action poses a threat to life and property within the surf zone. High surf criteria vary by region.",
    },
    high_surf_warning: {
      title: "High Surf Warning",
      description:
        " A High Surf Warning is issued when breaking wave action results in an especially heightened threat to life and property within the surf zone. High surf criteria varies by region.",
    },
    hurricane_force_wind_watch: {
      title: "Hurricane Force Wind Watch",
      description:
        "A watch for an increased risk of a hurricane force wind event for sustained surface winds, or frequent gusts, of 34 knots 64 knots (74 mph) or greater, but its occurrence, location, and/or timing is still uncertain.",
    },
    hurricane_local_statement: {
      title: "Hurricane Local Statement",
      description:
        "A hurricane local statement (HLS) is a weather statement produced for the public by the local Weather Forecast Offices of the National Weather Service in the U.S. for areas affected or forecast to be affected by a tropical storm or hurricane that provides an overview of the storm's local effects, including expected weather conditions, evacuation decisions made by local officials, and precautions necessary to protect life and property.",
    },
    hydrologic_advisory: {
      title: "Hydrologic Advisory",
      description:
        'To inform communities on non-gauged River or Flood Control Project ("Floodways") of significant water levels causing minor river flooding or flooding inside the levees.',
    },
    hydrologic_outlook: {
      title: "Hydrologic Outlook",
      description:
        "Issued as a seasonal, intra–seasonal outlook, or an outlook prior to a significant rain event which could lead to widespread flooding.",
    },
    lake_effect_snow_advisory: {
      title: "Lake Effect Snow Advisory",
      description:
        "This product is issued by the National Weather Service when pure lake effect snow (this is where the snow is a direct result of lake effect snow and not because of a low pressure system) may pose a hazard or it is life threatening. The criteria for this advisory varies from area to area.",
    },
    lake_effect_snow_warning: {
      title: "Lake Effect Snow Warning",
      description:
        "This product is issued by the National Weather Service when pure lake effect snow (this is where the snow is a direct result of lake effect snow and not because of a synoptic storm or low pressure system) may pose a hazard or it is life threatening.",
    },
    lake_effect_snow_watch: {
      title: "Lake Effect Snow Watch",
      description:
        "A lake effect snow watch was a bulletin issued by the National Weather Service in the United States to warn of heavy snowfall amounts that will be possible from convective snow generated by cold air masses passing over unfrozen lakes (lake effect snow).",
    },
    lake_wind_advisory: {
      title: "Lake Wind Advisory",
      description:
        "Issued for recreational boating interests during boating season (May–September) when sustained winds of at least 15 mph are forecast for more than one hour.",
    },
    lakeshore_flood_advisory: {
      title: "Lakeshore Flood Advisory",
      description:
        "Minor flooding is possible (i.e., over and above normal high tide levels.",
    },
    lakeshore_flood_statement: {
      title: "Lakeshore Flood Statement",
      description:
        "Lakeshore Flood Statement is issued when minor or nuisance lakeshore flooding is occurring or imminent.",
    },
    lakeshore_flood_warning: {
      title: "Lakeshore Flood Warning",
      description:
        "Lakeshore Flood Warning informs the public lakeshore flooding, posing a serious threat to life and property, is occurring, imminent, or highly likely in the next 12 hours.",
    },
    lakeshore_flood_watch: {
      title: "Lakeshore Flood Watch",
      description:
        "Lakeshore Flood Watch informs the public lakeshore flooding is possible. A watch should be issued 12 to 36 hours in advance.",
    },
    law_enforcement_warning: {
      title: "Law Enforcement Warning",
      description:
        "A law enforcement warning is a warning issued through the Emergency Alert System (EAS) in the United States to warn the public of criminal events that pose a threat to public safety.",
    },
    local_area_emergency: {
      title: "Local Area Emergency",
      description:
        " An emergency message that defines an event that by itself does not pose a significant threat to public safety and/or property. However, the event could escalate, contribute to other more serious events, or disrupt critical public safety services.",
    },
    low_water_advisory: {
      title: "Low Water Advisory",
      description:
        "An advisory to describe water levels which are significantly below average levels over the Great Lakes, coastal marine zones, and any tidal marine area, waterway, or river inlet within or adjacent to a marine zone that would potentially be impacted by low water conditions creating a hazard to navigation.",
    },
    marine_weather_statement: {
      title: "Marine Weather Statement",
      description:
        "A product to provide mariners with details on significant or potentially hazardous conditions not otherwise covered in existing marine warnings and forecasts.",
    },
    nuclear_power_plant_warning: {
      title: "Nuclear Power Plant Warning",
      description:
        "A warning of an event at a nuclear power plant classified such as a Site Area Emergency or General Emergency as classified by the Nuclear Regulatory Commission (NRC). A Site Area Emergency is confined to the plant site; no off-site impact is expected.",
    },
    radiological_hazard_warning: {
      title: "Radiological Hazard Warning",
      description:
        "A warning of the loss, discovery, or release of a radiological hazard.",
    },
    rip_current_statement: {
      title: "Rip Current Statement",
      description:
        "A rip current statement is a warning statement issued by the National Weather Service of the United States when there is a high threat of rip currents due to weather and ocean conditions.",
    },
    severe_weather_statement: {
      title: "Severe Weather Statement",
      description:
        "Bulletin issued to update or cancel a severe thunderstorm or tornado warning.",
    },
    shelter_in_place_warning: {
      title: "Shelter In Place Warning",
      description:
        "A warning of an event where the public is recommended to shelter in place (go inside, close doors and windows, turn off air conditioning or heating systems, and turn on the radio or TV for more information). An example is the release of hazardous materials where toxic fumes or radioactivity may affect designated areas.",
    },
    short_term_forecast: {
      title: "Short Term Forecast",
      description:
        "A product used to convey information regarding weather or hydrologic events in the next few hours.",
    },
    small_craft_advisory_for_hazardous_seas: {
      title: "Small Craft Advisory For Hazardous Seas",
      description:
        "An advisory for specialized areas near harbor or river entrances known as bars. Waves in or near such bars may be especially hazardous to mariners due to the interaction of swell, tidal and/or river currents in relatively shallow water.",
    },
    small_craft_advisory_for_rough_bar: {
      title: "Small Craft Advisory For Rough Bar",
      description:
        "An advisory for specialized areas near harbor or river entrances known as bars. Waves in or near such bars may be especially hazardous to mariners due to the interaction of swell, tidal and/or river currents in relatively shallow water.",
    },
    small_craft_advisory_for_winds: {
      title: "Small Craft Advisory For Winds",
      description:
        "An advisory for wave heights lower than small craft advisory criteria, yet wind speeds are potentially hazardous. Thresholds governing the issuance of small craft advisories are specific to geographic areas.",
    },
    small_stream_flood_advisory: {
      title: "Small Stream Flood Advisory",
      description:
        "This advisory alerts the public to flooding which is generally only an inconvenience (not life-threatening) to those living in the affected area. Issued when heavy rain will cause flooding of streets and low-lying places in urban areas. Also used if small rural or urban streams are expected to reach or exceed bankfull. Some damage to homes or roads could occur.",
    },
    snow_squall_warning: {
      title: "Snow Squall Warning",
      description:
        "Snow squall warnings are short-fused and focused on distinct areas (like tornado and severe thunderstorm warnings). These warnings provide critical, highly localized life-saving information. If a snow squall warning is issued for your area, avoid or delay motor travel until the squall passes through your location.",
    },

    special_weather_statement: {
      title: "Special Weather Statement",
      description:
        "A Special Weather Statement may be issued by the NWS for hazards that have not yet reached warning or advisory status or that do not have a specific code of their own, such as widespread funnel clouds. They are also occasionally used to clear counties from severe weather watches",
    },
    storm_surge_warning: {
      title: "Storm Surge Warning",
      description:
        "A storm surge warning is defined as the danger of life-threatening inundation from rising water moving inland from the shoreline somewhere within the specified area, generally within 36 hours, in association with a tropical, subtropical, or post-tropical cyclone.",
    },
    storm_surge_watch: {
      title: "Storm Surge Watch",
      description:
        "A storm surge watch is defined as the possibility of life-threatening inundation from rising water moving inland from the shoreline somwhere within the specified area, generally within 48 hours, in association with a tropical, subtropical, or post-tropical cyclone.",
    },

    storm_watch: {
      title: "Storm Watch",
      description:
        "A Tropical Storm Watch is issued when a tropical cyclone containing winds of 34 to 63 kt (39 to 73 mph) or higher poses a possible threat, generally within 48 hours. These winds may be accompanied by storm surge, coastal flooding, and/or river flooding. The watch does not mean that tropical storm conditions will occur.",
    },
    tropical_storm_local_statement: {
      title: "Tropical Storm Local Statement",
      description:
        "A hurricane/tropical storm local statement, issued every two to three hours by local National Weather Service (NWS) offices, summarizes all of the watches and warnings, evacuation information, and most immediate threats to an area.",
    },
    tsunami_advisory: {
      title: "Tsunami Advisory",
      description:
        "A tsunami with potential for strong currents or waves dangerous to those in or very near the water is expected or occurring. Stay out of the water and away from beaches and waterways. Follow instructions from local officials",
    },
    tsunami_warning: {
      title: "Tsunami Warning",
      description:
        "Follow instructions from local officials. Evacuation is recommended. Move to high ground or inland (away from the water). Tsunami Advisory: Take Action—A tsunami with potential for strong currents or waves dangerous to those in or very near the water is expected or occurring.",
    },
    tsunami_watch: {
      title: "Tsunami Watch",
      description:
        "A distant earthquake has occurred. Stay tuned for more information. Be prepared to take action if necessary. Tsunami Information Statement: Relax—An earthquake has occurred, but there is no threat or it was very far away and the threat has not been determined.",
    },
    urban_and_small_stream_flood_advisory: {
      title: "Urban And Small Stream Flood Advisory",
      description:
        "This advisory alerts the public to flooding which is generally only an inconvenience (not life-threatening) to those living in the affected area. Issued when heavy rain will cause flooding of streets and low-lying places in urban areas.",
    },
    volcano_warning: {
      title: "Volcano Warning",
      description:
        "A warning of current or imminent volcanic activity. Authorized officials may recommend or order protective actions according to state law or local ordinance.",
    },

    wind_chill_watch: {
      title: "Wind Chill Watch",
      description:
        "A wind chill watch is issued by the National Weather Service of the United States when the wind chill could reach dangerous levels within the next 12 to 48 hours.",
    },
  };

  getFieldMap(type: "cap" | "diff_check", key: string) {
    return type === "cap"
      ? this.capFieldMap[key as keyof typeof this.capFieldMap]
      : this.diffCheckFieldMap[key as keyof typeof this.diffCheckFieldMap];
  }

  getPreferences(
    subcategory: NotificationPreferenceSubcategoryDto,
  ): NotificationPreferenceSubcategoryItem[] {
    return [
      {
        ...this.preferencesFieldMap["email_enabled"],
        name: "email_enabled",
        value: subcategory.email_enabled,
      },
      {
        ...this.preferencesFieldMap["push_notifications"],
        value: subcategory.push_notifications,
        name: "push_notifications",
      },
    ];
  }
}
